import { useEffect } from "react"
import { IoClose } from "react-icons/io5"
import "../styles/prompts.css"

const ModalWrapper = ({ isOpen, onClose, title, children }) => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose()
            }
        }
        if (isOpen) {
            document.addEventListener("keydown", handleKeyDown)
        }
        return () => {
            document.removeEventListener("keydown", handleKeyDown)
        } 
    }, [isOpen, onClose])
  
    return (
        <div className={`modal-overlay ${isOpen ? "visible" : ""}`} onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button onClick={onClose} className="close-btn">
                    <IoClose />
                </button>
                {title && <h3>{title}</h3>}
                {children}
            </div>
        </div>
    )
}

export default ModalWrapper